import { useEffect } from "react";
import Lenis from "lenis";
import { Nav } from "./Nav";
import { Hero } from "./Hero";
import { Marquee } from "./Marquee";
import { FeaturedProject } from "./FeaturedProject";
import { StudioPrinciples } from "./StudioPrinciples";
import { Products } from "./Products";
import { About } from "./About";
import { FinalCTA } from "./FinalCTA";

export const Landing = () => {
  useEffect(() => {
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <Nav />
      <main>
        <Hero />
        <div className="mt-12 md:mt-16">
          <Marquee />
        </div>
        <FeaturedProject />
        <Products />
        <StudioPrinciples />
        <About />
      </main>
      <FinalCTA />
    </div>
  );
};
